import { render } from "./Agree.vue?vue&type=template&id=a64807a6"
import script from "./Agree.vue?vue&type=script&lang=js"
export * from "./Agree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__